import { Avatar } from "@mui/material";
import React from "react";
import Logo from "../assets/logoN3_transparent.png";
import 'animate.css';
import './full-loader.css'
const FullScreenLoading = () => {
  return (
    <div
      style={{
        position: "fixed" /* Sit on top of the page content */,
        width: "100%" /* Full width (cover the whole page) */,
        height: "100%" /* Full height (cover the whole page) */,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255,255,255,1)" /* Black background with opacity */,
        zIndex: 999999, 
        cursor: "pointer" /* Add a pointer on hover */,
        display: 'flex',
        justifyContent: 'center'
      }}
    >
        {/*  animation:'pulse', animationDuration: '1s' */}
      <img style={{alignSelf: 'center',}} className="animate__animated animate__pulse animate__infinite" alt="Logo" src={Logo} />
    </div>
  );
};

export default FullScreenLoading;
